import { BillingCycleTypes } from '../../domain/invoice';
import { SortItem, sortTypes, sortDirection } from './member.dashboard.license.response';
import { LicenseStatusTypes } from '../../domain/license';
import { ISortable } from '../../../../app/helpers/sort';


export enum OrderSystems {
    Unknown = 0,
    OrderForm = 1,
    MemberPanel = 2,
    TeamPanel = 3
}

export class SalesItem {

    DateTimeCreated: Date;
    MemberID: number;
    MemberName: string;
    DesignerName: string;
    CompanyName: string;
    LicenseKey: string;
    SalesRep: string;
    SalesRepID: number;
    LeadSource: string;
    ProductName: string;
    ProductID: string;
    Status: LicenseStatusTypes;
    BillingCycle: string;
    BillingCycleTypes: BillingCycleTypes;
    Amount: number;
    SoftwareVersion: string;
    OrderSystem: OrderSystems;

    public static FixDates(item: SalesItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}


export class SalesItemArray extends Array<SalesItem> implements ISortable {

    public LastSort = new SortItem;

    constructor(...items: SalesItem[]) {
        super(...items);
        Object.setPrototypeOf(this, SalesItemArray.prototype);
    }

    public static FixDates(items: SalesItemArray) {
        items.forEach(x => SalesItem.FixDates(x));
    }

    public static checkVariables(checkThis: SalesItemArray) {
        if (checkThis.LastSort == undefined) {
            checkThis.LastSort = new SortItem;
            checkThis.LastSort.SortType = sortTypes.ID;
            checkThis.LastSort.SortDirection = sortDirection.Unsorted;
        }
    }

}
